export enum LanguageEnum {
  DE = "de",
  FR = "fr",
  IT = "it",
  EN = "en",
}
